/****************************************
	Paging
*****************************************/
($ => {
	if ($.paging) {
		ui.warn('ERROR: You are including paging.js multiple times');
		return;
	}
	const paging = {
		create($element, options) {
			let instance = $element.data('pagingInstance');
			if (instance) {
				instance.destroy();
			}
			instance = Object.create(this.proto);
			instance.$element = $element;
			instance.config = Object.assign({}, this.staticProperties.defaults, instance._getOptionsFromDom(), options);
			if (!instance.config.total) {
				ui.warn('total must be passed in');
				instance.destroy();
				return false;
			}
			if (instance.config.allowSkipping === false) {
				ui.warn('DEPRECATION NOTICE: Please replace "allowSkipping: false" with "display: \'text\'"');
				instance.config.display = 'text';
			}
			instance.config.current = Math.min(instance.config.total, instance.config.current);
			$element
				.addClass('paging')
				.data('pagingInstance', instance)
				.html(instance._createHtml());
			instance.$input = $element.find('input, select');
			instance.$next = $element.find('.pagingNext');
			instance.$prev = $element.find('.pagingPrevious');
			instance.$dropdown = $element.find('.pagingSelect');
			instance._addEvents();
			return instance;
		},
		proto: {
			_addEvents() {
				const config = this.config;
				let allowPageChange = true;
				this.$element
					.on('click.paging', '.pagingNext, .pagingPrevious', e => {
						const $button = $(e.currentTarget);
						if ($button.hasClass('disabled')) {
							return false;
						}
						if (config.previousUrl || config.nextUrl) {
							return;
						}
						if ($button.hasClass('pagingNext')) {
							this.goToPage(config.current + 1);
						} else {
							this.goToPage(config.current - 1);
						}
						return false;
					})
					.on('focusin.paging', 'input', e => {
						setTimeout(() => {
							e.currentTarget.select();
						}, 1);
					})
					.on('focusout.paging', 'input', e => {
						if (allowPageChange) {
							this.goToPage($(e.currentTarget).val());
						}
						allowPageChange = true;
					})
					.on('keydown.paging', 'input', e => {
						if (e.which === ui.keyCodes.esc) {
							allowPageChange = false;
							$(e.currentTarget).val(config.current).blur(); /* Revert to original value */
						} else if (e.which === ui.keyCodes.enter) {
							$(e.currentTarget).blur();
							return false; /* Do not submit form, rather let focusout event handle page change */
						}
					})
					.on('change.paging', 'select', e => {
						this.goToPage($(e.currentTarget).val());
					});
			},
			_keepPageWithinRange(page) {
				if (page < 1) {
					return 1;
				}
				if (page > this.config.total) {
					return this.config.total;
				}
				return page;
			},
			_createDropdownOptions() {
				const config = this.config;
				let html = '';
				for (const key in config.allowedPages) {
					if (config.allowedPages.hasOwnProperty(key)) {
						const current = key === config.current.toString() ? ' selected' : '';
						html += this
							._getTemplate('option')
							.replace('{option}', key)
							.replace('{isSelected}', current);
					}
				}
				return html;
			},
			_createHtml() {
				const config = this.config;
				let current;
				let input;
				let pages;
				/* Page Selector Template */
				if (config.display === 'select' && config.allowedPages) {
					input = this._getTemplate('select');
					current = config.current;
					pages = this._createDropdownOptions();
				} else if (config.display === 'input') {
					input = this._getTemplate('input');
					current = config.current;
				} else {
					input = this._getTemplate('numText');
					current = ui.numberToLocaleString(config.current);
				}
				/* PreviousURL Template */
				let previousUrl;
				if (config.previousUrl) {
					previousUrl = config.previousUrl;
				} else if (config.allowedPages) {
					previousUrl = this._getPreviousAllowedUrl();
				} else {
					previousUrl = config.url + this._keepPageWithinRange(config.current - 1);
				}
				/* NextUrl Template */
				let nextUrl;
				if (config.nextUrl) {
					nextUrl = config.nextUrl;
				} else if (config.allowedPages) {
					nextUrl = this._getNextAllowedUrl();
				} else {
					nextUrl = config.url + this._keepPageWithinRange(config.current + 1);
				}
				return this
					._getTemplate('html')
					.replace('{input}', input)
					.replace('{current}', current)
					.replace('{pages}', pages)
					.replace('{enablePrevious}', config.current === 1 ? ' disabled" aria-disabled="true' : '')
					.replace('{max}', config.total)
					.replace('{total}', ui.numberToLocaleString(config.total))
					.replace('{enableNext}', config.current === config.total ? ' disabled" aria-disabled="true' : '')
					.replace('{previousUrl}', previousUrl)
					.replace('{nextUrl}', nextUrl);
			},
			destroy() {
				this.$element
					.html('')
					.off('.paging')
					.removeData('paging-current paging-next-url paging-previous-url paging-total paging-url pagingInstance')
					.removeClass('paging');
			},
			_disabledAttributes($element, removeAttributes) {
				if (removeAttributes) {
					$element
						.removeClass('disabled')
						.removeAttr('aria-disabled');
				} else {
					$element
						.addClass('disabled')
						.attr('aria-disabled', true);
				}
			},
			_getNextAllowedUrl() {
				return this.config.allowedPages[this.config.current + 1] || '#';
			},
			_getOptionsFromDom() {
				const dataOptions = {
					total: this.$element.filter('[data-paging-total]').data('paging-total'),
					current: this.$element.data('paging-current'),
					url: this.$element.data('paging-url'),
					nextUrl: this.$element.data('paging-next-url'),
					previousUrl: this.$element.data('paging-previous-url')
				};
				for (const key in dataOptions) {
					if (dataOptions.hasOwnProperty(key) && dataOptions[key] === undefined) {
						delete dataOptions[key];
					}
				}
				return dataOptions;
			},
			_getPreviousAllowedUrl() {
				return this.config.allowedPages[this.config.current - 1] || '#';
			},
			_getTemplate(template) {
				const langSets = paging.staticProperties.langSets;
				const resources = {
					prevPage: ui.localize(langSets, 'prevPage'),
					of: ui.localize(langSets, 'of'),
					nextPage: ui.localize(langSets, 'nextPage'),
					newPageNumber: ui.localize(langSets, 'newPageNumber'),
					selectPage: ui.localize(langSets, 'selectPage')
				};
				const html = {
					html: `<a href="{previousUrl}" class="pagingPrevious ancBtn silver icon iconArrowLeft{enablePrevious}" rel="prev" title="${resources.prevPage}"></a>{input}${resources.of} <span class="pagingMax">{total}</span></span><a class="pagingNext ancBtn silver icon iconArrowRight{enableNext}" href="{nextUrl}" rel="next" title="${resources.nextPage}"></a>`,
					input: `<input aria-label="${resources.newPageNumber}" type="number" value="{current}" min="1" max="{max}" /><span class="pagingMeta">`,
					numText: '<span class="pagingMeta"><span class="pagingNum">{current}</span> ',
					select: `<span class="form"><select aria-label="${resources.selectPage}" class="pagingSelect" id="selectSomething">{pages}</select></span><span class="pagingMeta">`,
					option: '<option {isSelected}>{option}</option>'
				};
				return html[template];
			},
			goToPage(page) {
				const config = this.config;
				let newPage = parseInt((page.toString()).replace(/[,.]/g, ''), 10);
				this.$input.removeClass('error');
				if (!ui.isNumber(newPage)) {
					this.$input.addClass('error');
					return false;
				}
				if (config.current === newPage) {
					return false;
				}
				newPage = this._keepPageWithinRange(newPage);
				this._disabledAttributes(this.$next.add(this.$prev), true);
				if (newPage === 1) {
					this._disabledAttributes(this.$prev);
				} else if (newPage === config.total) {
					this._disabledAttributes(this.$next);
				}
				this.$input.val(newPage);
				config.current = newPage;
				this.$element.find('.pagingNum').html(newPage);
				this.$prev.attr('href', config.allowedPages ? this._getPreviousAllowedUrl() : config.url + this._keepPageWithinRange(config.current - 1));
				this.$next.attr('href', config.allowedPages ? this._getNextAllowedUrl() : config.url + this._keepPageWithinRange(config.current + 1));
				if (config.onChange && config.onChange.apply(this.$element, [newPage]) !== true) {
					return false;
				}
				if (config.allowedPages && config.allowedPages[newPage] !== '') {
					window.location = config.allowedPages[newPage];
				} else {
					window.location = config.url + newPage;
				}
			},
			replaceDropdown(newAllowedPages) {
				this.config.allowedPages = newAllowedPages;
				this.$dropdown.html(this._createDropdownOptions());
				this.$prev.attr('href', this._getPreviousAllowedUrl());
				this.$next.attr('href', this._getNextAllowedUrl());
			}
		},
		staticProperties: {
			defaults: {
				current: 1,
				url: '#page=',
				onChange: false,
				display: 'input',
				allowedPages: false
			},
			langSets: {
				de: {
					newPageNumber: 'Geben Sie eine neue Seitennummer',
					nextPage: 'N&#228;chste Seite',
					of: 'von',
					prevPage: 'Vorherige Seite',
					selectPage: 'W&#xE4;hlen Sie eine neue Seitennummer aus'
				},
				en: {
					newPageNumber: 'Enter new page number',
					nextPage: 'Next Page',
					of: 'of',
					prevPage: 'Previous Page',
					selectPage: 'Select new page number'
				},
				es: {
					newPageNumber: 'Ingresa un nuevo n&#250;mero de p&#225;gina',
					nextPage: 'P&#225;gina siguiente',
					of: 'de',
					prevPage: 'P&#225;gina anterior',
					selectPage: 'Selecciona un nuevo n&#250;mero de p&#225;gina'
				},
				fr: {
					newPageNumber: 'Entrez le nouveau num&#233;ro de page',
					nextPage: 'Page suivante',
					of: 'de',
					prevPage: 'Page pr&#233;c&#233;dente',
					selectPage: 'S&#xE9;lectionnez un nouveau num&#xE9;ro de page'
				},
				it: {
					newPageNumber: 'Inserire il nuovo numero di pagina',
					nextPage: 'Pagina successiva',
					of: 'di',
					prevPage: 'Pagina precedente',
					selectPage: 'Seleziona un nuovo numero di pagina'
				},
				sv: {
					newPageNumber: 'Ange nytt sidnummer',
					nextPage: 'N&#228;sta sida',
					of: 'av',
					prevPage: 'F&#246;reg&#229;ende sida',
					selectPage: 'V&#xE4;lj nytt sidnummer'
				}
			}
		}
	};
	/* Plugin definition */
	$.fn.paging = function init(options, ...args) {
		/* We cannot use .each because that will break binding 2 sets together */
		const isMethodCall = typeof options === 'string'; /* If options is a string, we assume it refers to a method. */
		if (isMethodCall) {
			const instance = this.data('pagingInstance');
			if (!instance) {
				ui.warn(`Cannot call methods on paging prior to initialization; attempted to call method "${options}".`);
				return false;
			}
			if (!$.isFunction(instance[options]) || options.indexOf('_') === 0) {
				ui.warn(`No such method "${options}" for paging.`);
				return false;
			}
			const methodValue = instance[options](...args);
			if (methodValue !== instance && methodValue !== undefined) {
				return methodValue && methodValue.jquery ? this.pushStack(methodValue.get()) : methodValue;
			}
		} else {
			paging.create($(this), options);
		}
		return this;
	};
	/* Expose testable methods */
	$.paging = {
		getTest() {
			return Object.assign({}, paging);
		}
	};
	/* Auto-instantiate where needed. Must be separate to not be bound together. */
	$(() => $('[data-paging-total]:not([data-auto-instantiate="off"])').each((i, el) => {
		$(el).paging();
	}));
})(jQuery);
